import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import graphqlPropTypes from '@prisjakt/graphql-proptypes';
import { AppContext } from '@prisjakt/ui-app-context';
import { bemGenerator } from '@prisjakt/ui-base';
import ProductRow from '@prisjakt/ui-product-row';
import CloseIcon from 'mdi-react/CloseIcon';
import Button from '@prisjakt/ui-button';
import ProductImage from '@prisjakt/ui-product-image';

import ProductAlertForm from '../../../product-alert/components/product-alert-form';
import actions from '../../../sidebar/actions/alert';
import ProductSearch from '../../../../components/product-search';
import { ProductAlertPageFragment } from '../../../../types';

import './index.scss';

const styles = bemGenerator('product-alert-box', [
  'product',
  'header-info',
  'content',
  'search',
  'alert-form',
  'header',
  'header-title',
  'header-subtitle',
]);

class ProductAlertBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      item: undefined,
    };
  }

  getPrivacyUrl() {
    const { market, renderMode } = this.context;
    return (
      market.privacySettings[renderMode] || market.privacySettings.responsive
    ).privacyUrl;
  }

  render() {
    const {
      account,
      sending,
      error,
      createAlertRequest,
      removeAlertRequest,
      campaignName,
    } = this.props;

    const { t } = this.context;

    const { item } = this.state;
    const loggedIn = account.me;

    if (item) {
      item.stockStatus = 'in_stock';
    }

    return (
      <div className={styles.block}>
        <div className={styles.header}>
          <div className={styles['header-title']}>
            {t('campaigns', 'inactive-campaign.alert-box-title')}
          </div>
          <div className={styles['header-subtitle']}>
            {t('campaigns', 'inactive-campaign.alert-box-description', {
              campaignName,
            })}
          </div>
        </div>
        <div className={styles.content}>
          <div
            className={styles.search.withModifier({
              'logged-in': loggedIn,
            })}
          >
            {item ? (
              <div className={styles.product}>
                <ProductRow
                  key={item.id}
                  id={item.id}
                  link={item.semantic_id}
                  name={item.name}
                  image={<ProductImage name={item.name} src={item.image} />}
                  rating={item.rating}
                  price={item.price}
                />
                <Button
                  variant="icon"
                  color="primary"
                  onClick={() =>
                    this.setState({
                      item: undefined,
                    })
                  }
                  icon={<CloseIcon />}
                />
              </div>
            ) : (
              <ProductSearch
                onSelect={selectedItem => this.setState({ item: selectedItem })}
                showFloatingResult
                placeholder={t(
                  'campaigns',
                  'inactive-campaign.alert-box-search-placeholder'
                )}
              />
            )}
          </div>
          {item && (
            <div
              className={styles['alert-form'].withModifier({
                'logged-in': loggedIn,
              })}
            >
              <ProductAlertForm
                productAlertFormData={{
                  product: {
                    ...item,
                    priceSummary: { regular: item.priceRaw },
                  },
                }}
                disabled={sending}
                error={error}
                showTypeSelect={false}
                onCreate={alert => createAlertRequest(alert, item.pathName)}
                onRemove={alertId =>
                  removeAlertRequest(alertId, item.id, item.pathName)
                }
                privacyPolicyUri={this.getPrivacyUrl()}
                showCancel={false}
                alertType="PRICE_DROPS"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const { func, object, bool, shape, string, oneOfType } = PropTypes;

ProductAlertBox.contextType = AppContext;

ProductAlertBox.propTypes = {
  page: graphqlPropTypes(ProductAlertPageFragment),
  createAlertRequest: func.isRequired,
  removeAlertRequest: func.isRequired,
  sending: bool.isRequired,
  success: bool.isRequired,
  error: oneOfType([bool, string]).isRequired,
  account: shape({ me: object }),
  campaignName: string.isRequired,
};

ProductAlertBox.defaultProps = {
  page: undefined,
  account: { me: undefined },
};

export default connect(
  state => ({
    account: state.areas.account,
    sending: state.areas.productAlert.sending,
    success: state.areas.productAlert.success,
    error: state.areas.productAlert.error,
  }),
  actions
)(ProductAlertBox);
